module.exports = __webpack_public_path__ + "static/claims-hero-mobile.04d8b334.webp";